import { render, staticRenderFns } from "./HaveSavings.vue?vue&type=template&id=70d11628&"
import script from "./HaveSavings.vue?vue&type=script&lang=js&"
export * from "./HaveSavings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports